export const canteenUserRestrictedMessage = '本页面数据为学校数据，您当前账号为食堂用户，无查询权限！'

export const userTypeLabels = {
  '00': '系统用户',
  '01': '学校用户',
  '02': '食堂用户'
}
//对应的用户类型
const userTypeOptionValues = {
  '00': ['00', '01', '02'],
  '01': ['01', '02'],
  '02': ['02']
}

export function getStoredUserInfo() {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || '{}') || {}
  } catch (error) {
    return {}
  }
}

export function isCanteenUser(userInfo) {
  return String((userInfo || getStoredUserInfo()).userType || '') === '02'
}

export function isRouteRestrictedForCanteenUser(route) {
  const matched = route && route.matched ? route.matched : []
  return matched.some(item => item.meta && item.meta.restrictedForCanteenUser)
}

export function isCanteenUserRouteRestricted(route, userInfo) {
  return isCanteenUser(userInfo) && isRouteRestrictedForCanteenUser(route)
}

export function getUserTypeLabel(userType) {
  return userTypeLabels[String(userType || '')] || ''
}

export function getDefaultCreateUserType(currentUserType) {
  return String(currentUserType || '') === '02' ? '02' : '01'
}

export function getUserTypeOptions(currentUserType, extraUserType) {
  const values = (userTypeOptionValues[String(currentUserType || '01')] || ['01']).slice()
  const extraValue = String(extraUserType || '')
  if (extraValue && values.indexOf(extraValue) === -1) {
    values.push(extraValue)
  }
  return values.map(value => ({
    value,
    label: userTypeLabels[value] || value
  }))
}



// WEBPACK FOOTER //
// ./src/utils/restrictedAccess.js